<template>
  <div class="schedule">
    <match-tabs :top1="2" :matchId="matchId" :sportType="match.sportType"></match-tabs>
    <!-- 内容 -->
    <div class="activity-list" v-if="activityList.length > 0">
      <div v-for="game in activityList" :key="game.time">
        <div class="time">{{ game.time }}</div>
        <div v-for="item in game.games" :key="item.id" class="item">
          <div class="left">
            <img :src="filterImage(match.icon, 140, 140)" />
          </div>
          <div class="rigth">
            <div class="activity-item-name">{{ item.catalog }}</div>
            <div class="activity-item-state">
              <span class="activity-item-address">{{ item.location }}</span>
              <span class="activity-item-status">{{ item.gameStatus }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <vs-list v-for="item, i in list" :key="i" :item="item" :clothPrefix="clothPrefix"></vs-list>
    </div>
    <div class="aaa">赛事数据统计由组委会提供</div>
    <!-- 底部tabs -->
    <div class="footer">
      <div class="footer-box" ref="footer">
        <div v-for="item in rounds" :key="item.index + item.id || item.index" class="item"
          :class="{ selected: item.index === currentRound && (id === null || item.id === id) }"
          @click="goRound(item.index, item.id, item.stages)">{{ item.name }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import matchTabs from './components/MatchTabs'
import { getBMStageGamesByBMMatchId } from '@/api/match'
import { getWeekdayStringByDateString } from '@/utils'
import vsList from './components/VsList'
import { QNImageUtil } from '@/utils'
export default {
  components: { matchTabs, vsList },
  data() {
    return {
      matchId: null,
      active: 1,
      isGroupRound: 0,
      round: '',
      clothPrefix: 'qy_',
      list: [],
      activityList: [],
      maxRound: '',
      rounds: [],
      currentRound: undefined,
      match: {},
      id: null
    }
  },
  watch: {

  },
  mounted() {
    this.matchId = this.$route.query.matchId
    this.getBMStageGamesByBMMatchId(1)
  },
  methods: {
    getBMStageGamesByBMMatchId(i) {
      const obj = {
        matchId: this.matchId,
        isGroupRound: this.isGroupRound,
        round: this.round,
        stageId: this.id
      }
      if (i === 1) {
        delete obj.isGroupRound
        // delete obj.round
      }
      if (this.id) {
        delete obj.isGroupRound
      }
      getBMStageGamesByBMMatchId(obj).then(res => {
        const data = res.data
        const match = data.match
        const unionMatch = res.data.unionMatch
        document.title = data.match.chineseName.split('_')[1] + '-赛程榜'
        const shareObj = {
          title: match.chineseName.split('_')[0] + this.getPromotion(unionMatch.beginDate, unionMatch.endDate),
          abstract: match.chineseName.split('_')[1] + '/赛程榜',
          image: QNImageUtil.imageView(match.icon)
        }
        this.wxShare(shareObj)
        var games = data.games
        let activities = data.activities || []
        this.maxRound = data.maxRound || match.roundCount + match.knockoutRoundCount
        this.isGroupRound = (typeof data.isGroupRound === 'undefined' ? 1 : data.isGroupRound)
        this.id = data.stageId
        this.currentRound = data.round
        if (match.sportType === '篮球') {
          this.clothPrefix = 'basket_'
        }
        this.match = match
        for (var i = 0; i < games.length; i++) {
          if (games.gameNotBegin === 1) {
            games[i].gameStatus = '未开始'
          } else if (games.gameEnd === 0) {
            games[i].gameStatus = '进行中'
          } else {
            games[i].gameStatus = '已结束'
          }
          games[i].order = i + 1
        }
        var tag = 0
        if (data.isGroupRound === 0 && (match.knockoutRoundCount === data.round)) {
          tag = 1
        }
        this.list = this.groupGames(games, tag)
        var rounds = []
        if (match.isBangSaiShi === 1 && data.stages.length >= 1) {
          data.stages.forEach((item, index) => {
            for (let i = 1; i <= item.roundCount; i++) {
              let label = item.stageName + '第' + i + '轮'
              if (item.roundAliasList) {
                const obj = item.roundAliasList.find(a => a.round === i) || null
                if (obj) {
                  label = obj.alias
                }
              }
              rounds.push({
                index: i,
                id: item.id,
                stages: index,
                name: label
              })
            }
          });
        } else {
          for (let i = 1; i <= this.maxRound; i++) {
            var isGroupRound = i <= match.roundCount
            var round = isGroupRound ? i : i - match.roundCount
            rounds.push({
              index: i,
              name: this.getDefaultRoundDescription(isGroupRound, round, match)
            })
          }
        }
        function getDateObjectByString(dateString) {
          var convertedDateString = dateString.replace(/-/g, "/").replace("T", " ").replace(/\+[0-9:]+/ig, "");//为了兼容ios的时间格式转化
          return new Date(convertedDateString);
        }
        function isActivityStarted(activity) {
          var beginDate = getDateObjectByString(activity.beginDate);
          return beginDate - Date.now() < 0;
        }
        function isActivityEnd(activity) {
          var endDate = getDateObjectByString(activity.endDate);
          return endDate - Date.now() < 0;
        }
        for (let i = 0; i < activities.length; i++) {
          if (activities[i].liveStatus) {
            activities[i].gameStatus = activities[i].liveStatus.statusLabel;
          } else {
            if (!isActivityStarted(activities[i])) {
              activities[i].gameStatus = "未开始";
            } else if (!isActivityEnd(activities[i])) {
              activities[i].gameStatus = "进行中";
            } else {
              activities[i].gameStatus = "已结束";
            }

          }
        }
        this.activityList = this.groupGames(activities);
        this.rounds = rounds
        console.log(rounds);
        this.$nextTick(() => {
          const bol = rounds.length === this.currentRound || rounds.length === this.currentRound + 1 || rounds.length === this.currentRound + 2
          if (bol) {
            this.$refs.footer.scrollLeft = this.$refs.footer.scrollWidth
          }
          const i = rounds.findIndex(r => r.id === this.id && r.index === this.currentRound)
          if (i > -1 && rounds.length > 0) {
            const d = this.$refs.footer.scrollWidth / rounds.length
            const m = d * i + d / 2
            const pageWidth = document.documentElement.clientWidth || document.body.clientWidth;
            const movePX = m - pageWidth / 2
            if (movePX > 0) {
              this.$refs.footer.scrollLeft = movePX
            }
          }
        })
      })
    },
    getPromotion(createDate, endDate) {
      const startTime = new Date(createDate)
      const endTime = new Date(endDate)
      const currentTime = new Date()
      if (currentTime < startTime) {
        return '-敬请期待';
      } else if (currentTime >= startTime && currentTime <= endTime) {
        return '-激战正酣';
      } else {
        return '-完美闭幕';
      }
    },
    filterImage(img, w, h, mode) {
      return QNImageUtil.imageView(img, parseInt(2 * w, 10), parseInt(2 * h, 10), mode)
    },
    getDefaultRoundDescription(isGroupRound, round, match) {
      var description = ''

      console.log(match, 'match');
      if (!isGroupRound) {
        if (round > match.knockoutRoundCount) { // 理论上，此时round是不可能大于knockoutRoundCount的
          round = match.knockoutRoundCount// 修正Server端的数据异常，提高容错性。
        }
        if (round === match.knockoutRoundCount) {
          description = '决赛'
        } else if (round === match.knockoutRoundCount - 1) {
          description = '半决赛'
        } else {
          description = '1/' + Math.pow(2, match.knockoutRoundCount - round) + '决赛'
        }
      } else {
        if (round > match.roundCount) { // 理论上，此时round是不可能大于roundCount的
          round = match.roundCount// 修正Server端的数据异常，提高容错性。
        }
        var prefix = match.type === 'cup' ? '小组赛 ' : ''
        description = prefix + '第' + round + '轮'
      }
      return description
    },

    goRound(round, id, index) {
      this.id = id || null
      var match = this.match
      if (match.type === 'cup') {
        this.isGroupRound = round <= match.roundCount ? 1 : 0
      }
      if (this.id === null) {
        this.round = (round <= match.roundCount ? round : round - match.roundCount)
      } else {
        this.round = round
      }

      if (this.id) {
        let num = this.rounds.findIndex(item => item.stages === index && item.index === round)
        this.$nextTick(() => {
          this.$refs.footer.scrollLeft = this.$refs.footer.scrollWidth / this.rounds.length * num - (this.$refs.footer.clientWidth / 2)
        })
      } else {
        this.$nextTick(() => {
          this.$refs.footer.scrollLeft = this.$refs.footer.scrollWidth / this.rounds.length * round - (this.$refs.footer.clientWidth / 2)
        })
      }
      this.getBMStageGamesByBMMatchId()
    },
    groupGames(games, isLastRound) {
      var i; var gameGroupObject = {}
      for (i = 0; i < games.length; i++) {
        var game = games[i]
        var gameDateStringKey = '比赛时间待定'
        if (game.beginDate) {
          gameDateStringKey = game.beginDate.substring(0, 16).replace(/-/g, '/').replace('T', '  ' + getWeekdayStringByDateString(game.beginDate, true) + '  ')
        }
        if (gameGroupObject[gameDateStringKey]) {
          var gamesAtSameTime = gameGroupObject[gameDateStringKey]
          gamesAtSameTime.push(game)
        } else {
          gameGroupObject[gameDateStringKey] = [game]
        }
      }
      var gameGroups = []
      var keys = Object.keys(gameGroupObject)
      var orderedKeys = keys.sort()
      if (isLastRound) {
        orderedKeys.reverse()
      }
      for (i = 0; i < orderedKeys.length; i++) {
        var gamesInGroup = gameGroupObject[orderedKeys[i]]
        
        var gameGroup = { time: orderedKeys[i], games: gamesInGroup }
        gameGroups.push(gameGroup)
      }
      return gameGroups
    }
  }
}
</script>

<style scoped lang="scss">
.schedule {
  padding-bottom: 60px;
}

.activity-list {
  .time {
    background-color: #F2F2F2;
    font-size: 14px;
    text-align: center;
    height: 30px;
    line-height: 30px;
  }

  .item {
    display: flex;
    padding: 10px 0;
    box-sizing: border-box;

    .left {
      width: 20%;
      text-align: center;

      img {
        width: 52px;
        height: 52px;
      }
    }

    .rigth {
      width: 80%;
      padding: 5px 15px 5px 0;

      .activity-item-name {
        font-size: 16px;
      }

      .activity-item-state {
        margin-top: 5px;
        color: #ababab;
      }

      .activity-item-address {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 70%;
        display: inline-block;
        font-size: 13px;
      }

      .activity-item-status {
        float: right;
        font-size: 13px;
      }
    }
  }
}

.aaa {
  font-size: 13px;
  color: #b5b5b5;
  margin: 10px auto;
  text-align: center;
}

.footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: #fff;
  padding-bottom: 20px;

  .footer-box {
    overflow-x: scroll;
    white-space: nowrap;
    display: flex;
    text-align: center;
    border-top: solid 1px lightgrey;

    .item {
      padding: 12px;
      font-size: 14px;
      box-sizing: border-box;
    }

    .selected {
      border-top: solid 3px #b40000;
      color: #B40000;
    }
  }
}
</style>
